import React, { useState } from "react";

import AgroTradeHeader from "../components/Header";
import LandingFooter from "../../landing/components/Footer";

const govOrgs = [
    { id: "akimat", name: "Акимат", description: "Региональные программы поддержки агропроизводителей." },
    { id: "amanat", name: "Аманат", description: "Страховые и финансовые инструменты для фермеров." },
    { id: "akk", name: "АКК", description: "Аграрная кредитная корпорация и её сервисы." },
];

function GovPage() {
    const [selectedId, setSelectedId] = useState(govOrgs[0].id);
    const selected = govOrgs.find((g) => g.id === selectedId) || govOrgs[0];

    return (
        <div className="def_background min-h-screen flex flex-col">
            <AgroTradeHeader />
            <main className="flex-1">
                <div className="max-w-[1200px] mx-auto w-full px-4 py-10 lg:px-0 grid gap-10 lg:grid-cols-[minmax(260px,320px)_1fr]">
                    <section>
                        <h1 className="text-2xl font-semibold mb-4">Государственные органы</h1>
                        <div className="space-y-3">
                            {govOrgs.map((org) => {
                                const active = org.id === selectedId;
                                return (
                                    <button
                                        key={org.id}
                                        onClick={() => setSelectedId(org.id)}
                                        className={`w-full rounded-md border px-4 py-3 text-left text-sm transition ${
                                            active
                                                ? "border-[#147F26] bg-[#147F26]/5"
                                                : "border-[#e5e7eb] bg-white hover:border-[#147F26]"
                                        }`}
                                    >
                                        {org.name}
                                    </button>
                                );
                            })}
                        </div>
                    </section>

                    <section className="rounded-xl border border-[#e5e7eb] bg-white p-5">
                        <h2 className="text-lg font-semibold mb-2">{selected.name}</h2>
                        <p className="text-sm text-[#4b5563] mb-4">{selected.description}</p>
                        <p className="text-xs text-[#6b7280]">
                            Здесь будет подробная информация о сервисах, которые данный гос.орган
                            оказывает через платформу AgroTrade, а также ссылки на нормативные акты и
                            внешние ресурсы.
                        </p>
                    </section>
                </div>
            </main>
            <LandingFooter />
        </div>
    );
}

export default GovPage;

